/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface WordDictionaryControllerFindListResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 단어장 ID */
    _id: string;
    /** 단어장 이름 */
    name: string;
    /** 유형 (옵셔널 자유 문자열) */
    category?: string;
    /** 정렬 순서 - 값이 클수록 목록 상단(먼저)에 표시됨 */
    sortNum: number;
    /** 수정 시각 */
    updatedAt?: string;
    /** 언어별 대표 번역어 */
    entries: {
      /** ISO 언어 코드 */
      languageCode: string;
      /** 대표 번역어 */
      primary: string;
    }[];
  }[];
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface WordDictionaryControllerFindByIdResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 단어장 ID */
    _id: string;
    /** 병원 ID */
    hospitalID: string;
    /** 단어장 이름 */
    name: string;
    /** 단어장 설명 */
    description?: string | null;
    /** 유형 (옵셔널 자유 문자열) */
    category?: string;
    /** 정렬 순서 - 값이 클수록 목록 상단(먼저)에 표시됨 */
    sortNum: number;
    /** 언어별 대표 표기 목록 (ko, LANGUAGE_ORDER 순) */
    entries: {
      /** ISO 언어 코드 */
      languageCode: string;
      /** 대표 번역어 */
      primary: string;
    }[];
    /** 언어 구분 없는 단일 별칭 풀 */
    aliases: string[];
    /** 소프트 삭제 여부 */
    isRemoved: boolean;
    /** 최종 수정자 User ID */
    modifierID?: string;
    /** 최종 수정자 이름 (realName 우선, 없으면 name) */
    modifierName?: string;
    /** 생성 시각 */
    createdAt?: string;
    /** 수정 시각 */
    updatedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface WordDictionaryControllerUpdateBodyRequest {
  /** 병원 ID */
  hospitalID: string;
  /** 단어장 이름 */
  name: string;
  /** 단어장 설명 */
  description?: string | null;
  /** 유형 (옵셔널 자유 문자열). 키 자체를 생략하면 변경 없음, 빈 문자열을 보내면 명시적 클리어. */
  category?: string;
  /** 언어별 대표 표기 목록 (한국어 ko 항목 필수) */
  entries: {
    /** ISO 언어 코드 (예: ko, en, zh-CN) */
    languageCode: string;
    /** 대표 번역어 (원본 보존, 매칭 시 출력값) */
    primary: string;
  }[];
  /**
   * 언어 구분 없는 단일 별칭 풀 (매칭/중복 체크 후보)
   * @default []
   */
  aliases: string[];
}

export interface WordDictionaryControllerUpdateResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 단어장 ID */
    _id: string;
    /** 병원 ID */
    hospitalID: string;
    /** 단어장 이름 */
    name: string;
    /** 단어장 설명 */
    description?: string | null;
    /** 유형 (옵셔널 자유 문자열) */
    category?: string;
    /** 정렬 순서 - 값이 클수록 목록 상단(먼저)에 표시됨 */
    sortNum: number;
    /** 언어별 대표 표기 목록 (ko, LANGUAGE_ORDER 순) */
    entries: {
      /** ISO 언어 코드 */
      languageCode: string;
      /** 대표 번역어 */
      primary: string;
    }[];
    /** 언어 구분 없는 단일 별칭 풀 */
    aliases: string[];
    /** 소프트 삭제 여부 */
    isRemoved: boolean;
    /** 최종 수정자 User ID */
    modifierID?: string;
    /** 최종 수정자 이름 (realName 우선, 없으면 name) */
    modifierName?: string;
    /** 생성 시각 */
    createdAt?: string;
    /** 수정 시각 */
    updatedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface WordDictionaryControllerSoftDeleteResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 단어장 ID */
    _id: string;
    /** 병원 ID */
    hospitalID: string;
    /** 단어장 이름 */
    name: string;
    /** 단어장 설명 */
    description?: string | null;
    /** 유형 (옵셔널 자유 문자열) */
    category?: string;
    /** 정렬 순서 - 값이 클수록 목록 상단(먼저)에 표시됨 */
    sortNum: number;
    /** 언어별 대표 표기 목록 (ko, LANGUAGE_ORDER 순) */
    entries: {
      /** ISO 언어 코드 */
      languageCode: string;
      /** 대표 번역어 */
      primary: string;
    }[];
    /** 언어 구분 없는 단일 별칭 풀 */
    aliases: string[];
    /** 소프트 삭제 여부 */
    isRemoved: boolean;
    /** 최종 수정자 User ID */
    modifierID?: string;
    /** 최종 수정자 이름 (realName 우선, 없으면 name) */
    modifierName?: string;
    /** 생성 시각 */
    createdAt?: string;
    /** 수정 시각 */
    updatedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface WordDictionaryControllerCreateBodyRequest {
  /** 병원 ID */
  hospitalID: string;
  /** 단어장 이름 (서버가 ko entry/대표 별칭으로 그대로 사용) */
  name: string;
  /** 단어장 설명 */
  description?: string;
  /** 유형 (필수 문자열) */
  category: string;
}

export interface WordDictionaryControllerCreateResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 단어장 ID */
    _id: string;
    /** 병원 ID */
    hospitalID: string;
    /** 단어장 이름 */
    name: string;
    /** 단어장 설명 */
    description?: string | null;
    /** 유형 (옵셔널 자유 문자열) */
    category?: string;
    /** 정렬 순서 - 값이 클수록 목록 상단(먼저)에 표시됨 */
    sortNum: number;
    /** 언어별 대표 표기 목록 (ko, LANGUAGE_ORDER 순) */
    entries: {
      /** ISO 언어 코드 */
      languageCode: string;
      /** 대표 번역어 */
      primary: string;
    }[];
    /** 언어 구분 없는 단일 별칭 풀 */
    aliases: string[];
    /** 소프트 삭제 여부 */
    isRemoved: boolean;
    /** 최종 수정자 User ID */
    modifierID?: string;
    /** 최종 수정자 이름 (realName 우선, 없으면 name) */
    modifierName?: string;
    /** 생성 시각 */
    createdAt?: string;
    /** 수정 시각 */
    updatedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface WordDictionaryControllerReorderBodyRequest {
  /** 이동 대상을 이 단어장 ID 바로 아래(이 단어장이 위 이웃이 됨) 자리로 이동. 최하단으로 보내려면 현재 최하단 단어장 ID 를 지정. atTop 과 동시 지정 불가. */
  beforeID?: string;
  /** true 면 최상단(max sortNum + 1)으로 이동. beforeID 와 동시 지정 불가. */
  atTop?: boolean;
}

export interface WordDictionaryControllerReorderResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 단어장 ID */
    _id: string;
    /** 병원 ID */
    hospitalID: string;
    /** 단어장 이름 */
    name: string;
    /** 단어장 설명 */
    description?: string | null;
    /** 유형 (옵셔널 자유 문자열) */
    category?: string;
    /** 정렬 순서 - 값이 클수록 목록 상단(먼저)에 표시됨 */
    sortNum: number;
    /** 언어별 대표 표기 목록 (ko, LANGUAGE_ORDER 순) */
    entries: {
      /** ISO 언어 코드 */
      languageCode: string;
      /** 대표 번역어 */
      primary: string;
    }[];
    /** 언어 구분 없는 단일 별칭 풀 */
    aliases: string[];
    /** 소프트 삭제 여부 */
    isRemoved: boolean;
    /** 최종 수정자 User ID */
    modifierID?: string;
    /** 최종 수정자 이름 (realName 우선, 없으면 name) */
    modifierName?: string;
    /** 생성 시각 */
    createdAt?: string;
    /** 수정 시각 */
    updatedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface WordDictionaryControllerUpdateNameCategoryBodyRequest {
  /** 단어장 이름 (옵셔널). 키를 생략하면 변경 없음. 보낼 경우 trim 후 빈 문자열이면 400. 동일 hospitalID 의 다른 단어장 이름과 중복되면 40001. */
  name?: string;
  /** 유형 (필수 자유 문자열). trim 후 빈 값이면 40002. 중복 허용. */
  category: string;
}

export interface WordDictionaryControllerUpdateNameCategoryResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 단어장 ID */
    _id: string;
    /** 병원 ID */
    hospitalID: string;
    /** 단어장 이름 */
    name: string;
    /** 단어장 설명 */
    description?: string | null;
    /** 유형 (옵셔널 자유 문자열) */
    category?: string;
    /** 정렬 순서 - 값이 클수록 목록 상단(먼저)에 표시됨 */
    sortNum: number;
    /** 언어별 대표 표기 목록 (ko, LANGUAGE_ORDER 순) */
    entries: {
      /** ISO 언어 코드 */
      languageCode: string;
      /** 대표 번역어 */
      primary: string;
    }[];
    /** 언어 구분 없는 단일 별칭 풀 */
    aliases: string[];
    /** 소프트 삭제 여부 */
    isRemoved: boolean;
    /** 최종 수정자 User ID */
    modifierID?: string;
    /** 최종 수정자 이름 (realName 우선, 없으면 name) */
    modifierName?: string;
    /** 생성 시각 */
    createdAt?: string;
    /** 수정 시각 */
    updatedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface WordDictionaryControllerAppendAliasBodyRequest {
  /** aliases 끝에 추가할 단어 하나 */
  alias: string;
}

export interface WordDictionaryControllerAppendAliasResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 단어장 ID */
    _id: string;
    /** 병원 ID */
    hospitalID: string;
    /** 단어장 이름 */
    name: string;
    /** 단어장 설명 */
    description?: string | null;
    /** 유형 (옵셔널 자유 문자열) */
    category?: string;
    /** 정렬 순서 - 값이 클수록 목록 상단(먼저)에 표시됨 */
    sortNum: number;
    /** 언어별 대표 표기 목록 (ko, LANGUAGE_ORDER 순) */
    entries: {
      /** ISO 언어 코드 */
      languageCode: string;
      /** 대표 번역어 */
      primary: string;
    }[];
    /** 언어 구분 없는 단일 별칭 풀 */
    aliases: string[];
    /** 소프트 삭제 여부 */
    isRemoved: boolean;
    /** 최종 수정자 User ID */
    modifierID?: string;
    /** 최종 수정자 이름 (realName 우선, 없으면 name) */
    modifierName?: string;
    /** 생성 시각 */
    createdAt?: string;
    /** 수정 시각 */
    updatedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface WordDictionaryControllerRemoveAliasBodyRequest {
  /** aliases 에서 제거할 단어 하나 */
  alias: string;
}

export interface WordDictionaryControllerRemoveAliasResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 단어장 ID */
    _id: string;
    /** 병원 ID */
    hospitalID: string;
    /** 단어장 이름 */
    name: string;
    /** 단어장 설명 */
    description?: string | null;
    /** 유형 (옵셔널 자유 문자열) */
    category?: string;
    /** 정렬 순서 - 값이 클수록 목록 상단(먼저)에 표시됨 */
    sortNum: number;
    /** 언어별 대표 표기 목록 (ko, LANGUAGE_ORDER 순) */
    entries: {
      /** ISO 언어 코드 */
      languageCode: string;
      /** 대표 번역어 */
      primary: string;
    }[];
    /** 언어 구분 없는 단일 별칭 풀 */
    aliases: string[];
    /** 소프트 삭제 여부 */
    isRemoved: boolean;
    /** 최종 수정자 User ID */
    modifierID?: string;
    /** 최종 수정자 이름 (realName 우선, 없으면 name) */
    modifierName?: string;
    /** 생성 시각 */
    createdAt?: string;
    /** 수정 시각 */
    updatedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface WordDictionaryControllerFindParams {
  /** 병원 ID */
  hospitalID: string;
  /**
   * 건너뛸 건수
   * @default "0"
   */
  skip?: string;
  /**
   * 조회할 건수 (최대 300)
   * @default "300"
   */
  limit?: string;
  /** 검색어 (부분일치). name / termsNormalized (primary + aliases 정규화 통합 풀) 중 하나라도 매치되면 결과에 포함. */
  keyword?: string;
}

export type WordDictionaryControllerFindData = WordDictionaryControllerFindListResponse;

export type WordDictionaryControllerFindByIdData = WordDictionaryControllerFindByIdResponse;

export type WordDictionaryControllerUpdateData = WordDictionaryControllerUpdateResponse;

export type WordDictionaryControllerSoftDeleteData = WordDictionaryControllerSoftDeleteResponse;

export type WordDictionaryControllerData = WordDictionaryControllerCreateResponse;

export type WordDictionaryControllerReorderData = WordDictionaryControllerReorderResponse;

export type WordDictionaryControllerUpdateNameCategoryData = WordDictionaryControllerUpdateNameCategoryResponse;

export type WordDictionaryControllerAppendAliasData = WordDictionaryControllerAppendAliasResponse;

export type WordDictionaryControllerRemoveAliasData = WordDictionaryControllerRemoveAliasResponse;

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import { axiosInstance } from '../../../../instances/axios-instance';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axiosInstance;
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title AfterDoc API
 * @version 1.0.0
 * @baseUrl https://dev.api.afterdoc.net
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  v3 = {
    /**
     * @description hospitalID 를 기준으로 단어장 목록을 페이지네이션 조회한다. sortNum 내림차순으로 정렬되며 (값이 클수록 먼저 표시됨), isRemoved 는 결과에서 제외된다. keyword 가 주어지면 name / termsNormalized (primary + aliases 정규화 통합 풀) 중 하나라도 부분일치하는 단어장만 반환한다.
     *
     * @tags V3-WordDictionary
     * @name WordDictionaryControllerFind
     * @summary 단어장 목록 조회
     * @request GET:/v3/api/word-dictionary/list
     * @secure
     * @response `200` `WordDictionaryControllerFindData` success
     */
    wordDictionaryControllerFind: (query: WordDictionaryControllerFindParams, params: RequestParams = {}) =>
      this.request<WordDictionaryControllerFindData, any>({
        path: `/v3/api/word-dictionary/list`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 단어장 ID 기준으로 단일 조회. entries 는 ko 를 시작으로 LANGUAGE_ORDER 순으로 정렬된다. modifierID 는 populate 되어 modifierName (realName fallback name) 으로 노출된다. (MDP-1227)
     *
     * @tags V3-WordDictionary
     * @name WordDictionaryControllerFindById
     * @summary 단어장 상세 조회
     * @request GET:/v3/api/word-dictionary/{id}
     * @secure
     * @response `200` `WordDictionaryControllerFindByIdData` success
     */
    wordDictionaryControllerFindById: (id: any, params: RequestParams = {}) =>
      this.request<WordDictionaryControllerFindByIdData, any>({
        path: `/v3/api/word-dictionary/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description entries 와 top-level aliases 는 통째로 재정의된다 (덮어쓰기). 자기 자신을 제외한 {hospitalID, name} 중복 체크 + 다른 단어장의 termsNormalized 와 단어 단위 충돌 체크 (코드 40010). category 는 옵셔널로 함께 갱신할 수 있다 (키 자체를 생략하면 변경 없음, 빈 문자열을 보내면 명시적 클리어). 정렬 순서(sortNum) 변경은 본 엔드포인트가 아니라 PATCH /v3/api/word-dictionary/{id}/sort-num 에서만 처리한다. (MDP-1225)
     *
     * @tags V3-WordDictionary
     * @name WordDictionaryControllerUpdate
     * @summary 단어장 수정 (편집 폼 풀 업데이트)
     * @request PATCH:/v3/api/word-dictionary/{id}
     * @secure
     * @response `200` `WordDictionaryControllerUpdateData` success
     */
    wordDictionaryControllerUpdate: (
      id: any,
      data: WordDictionaryControllerUpdateBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<WordDictionaryControllerUpdateData, any>({
        path: `/v3/api/word-dictionary/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description isRemoved=true 로 설정. modifierID/updatedAt 갱신. 응답에는 삭제 후 상세 정보가 그대로 노출된다. (MDP-1226)
     *
     * @tags V3-WordDictionary
     * @name WordDictionaryControllerSoftDelete
     * @summary 단어장 삭제 (소프트 삭제)
     * @request DELETE:/v3/api/word-dictionary/{id}
     * @secure
     * @response `200` `WordDictionaryControllerSoftDeleteData` success
     */
    wordDictionaryControllerSoftDelete: (id: any, params: RequestParams = {}) =>
      this.request<WordDictionaryControllerSoftDeleteData, any>({
        path: `/v3/api/word-dictionary/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description name 만 필수 입력. 서버가 entries=[{ko, name}], aliases=[name] 을 자동 구성한다. {hospitalID, name} 조합은 unique. 또한 input.name 의 정규화 값이 동일 hospitalID 내 다른 단어장의 termsNormalized 와 겹치면 거부된다 (코드 40010). category 는 필수 자유 문자열 (trim 후 빈 값이면 40002). sortNum 은 서버가 자동 부여한다 (동일 hospitalID 의 최대 sortNum + 1, 없으면 5000 부터 시작 — 값이 클수록 목록 상단에 표시됨). 동일 hospitalID 의 활성(isRemoved=false) 단어장이 300개에 도달한 상태에서는 신규 생성이 거부된다 (코드 40030). (MDP-1228)
     *
     * @tags V3-WordDictionary
     * @name WordDictionaryController
     * @summary 단어장 등록
     * @request POST:/v3/api/word-dictionary
     * @secure
     * @response `200` `WordDictionaryControllerData` success
     */
    wordDictionaryController: (data: WordDictionaryControllerCreateBodyRequest, params: RequestParams = {}) =>
      this.request<WordDictionaryControllerData, any>({
        path: `/v3/api/word-dictionary`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description body 에 atTop 또는 beforeID 중 정확히 하나를 지정한다. atTop=true 면 동일 hospitalID 내 최상단(max sortNum + 1)으로 이동. beforeID 가 주어지면 이동 대상을 해당 단어장 바로 아래 자리에 끼워넣고 (해당 단어장이 위 이웃이 됨), 해당 단어장과 그 위 항목들은 +1 cascade shift. 최하단으로 이동하려면 현재 최하단 단어장을 beforeID 로 지정한다. 자기 자신을 beforeID 로 지정하거나 isRemoved=true 인 단어장을 beforeID 로 지정하면 400.
     *
     * @tags V3-WordDictionary
     * @name WordDictionaryControllerReorder
     * @summary 단어장 정렬 순서 변경
     * @request PATCH:/v3/api/word-dictionary/{id}/sort-num
     * @secure
     * @response `200` `WordDictionaryControllerReorderData` success
     */
    wordDictionaryControllerReorder: (
      id: any,
      data: WordDictionaryControllerReorderBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<WordDictionaryControllerReorderData, any>({
        path: `/v3/api/word-dictionary/${id}/sort-num`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description top-level name / category 두 필드만 갱신하는 가벼운 PATCH. category 는 필수(trim 후 빈 값이면 40002), name 은 옵셔널(생략 시 변경 없음) — 최소 { category } 만으로 유형을 수정할 수 있다. entries / aliases / termsNormalized 는 손대지 않으므로, 결과적으로 name 과 entries[ko].primary 가 다른 상태가 정상으로 인정된다 (검색/매칭은 termsNormalized 기반). name 이 들어오면 자기 자신 제외 {hospitalID, name} 중복 체크 (40001). 다른 단어장의 termsNormalized 와의 충돌(40010)은 검사하지 않는다. category 는 중복 허용.
     *
     * @tags V3-WordDictionary
     * @name WordDictionaryControllerUpdateNameCategory
     * @summary 단어장 이름/유형 부분 수정
     * @request PATCH:/v3/api/word-dictionary/{id}/name-category
     * @secure
     * @response `200` `WordDictionaryControllerUpdateNameCategoryData` success
     */
    wordDictionaryControllerUpdateNameCategory: (
      id: any,
      data: WordDictionaryControllerUpdateNameCategoryBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<WordDictionaryControllerUpdateNameCategoryData, any>({
        path: `/v3/api/word-dictionary/${id}/name-category`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description aliases 끝에 단어 하나를 추가한다. 동일 hospitalID 의 다른 단어장 termsNormalized 와 충돌하거나 자기 자신에 이미 동일(정규화 기준) 단어가 있으면 40010 으로 거부. 정규화 후 빈 문자열이면 400.
     *
     * @tags V3-WordDictionary
     * @name WordDictionaryControllerAppendAlias
     * @summary 단어장 aliases 단어 하나 추가 (인라인)
     * @request POST:/v3/api/word-dictionary/{id}/aliases
     * @secure
     * @response `200` `WordDictionaryControllerAppendAliasData` success
     */
    wordDictionaryControllerAppendAlias: (
      id: any,
      data: WordDictionaryControllerAppendAliasBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<WordDictionaryControllerAppendAliasData, any>({
        path: `/v3/api/word-dictionary/${id}/aliases`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description aliases 풀에서 단어 하나를 제거한다. raw 정확 문자열 매칭(trim 후)으로 대상을 찾으며, 동일 값이 여러 개면 모두 제거된다. aliases 에 일치 항목이 없으면 idempotent (DB 변경 없이 현재 상세를 그대로 반환). termsNormalized 는 단순 제거가 아니라 남은 entries/aliases 로 재계산되므로, 제거한 단어의 정규화 값을 다른 alias 나 entry primary 가 여전히 공유하면 termsNormalized 에는 남는다. 제거는 term 풀을 줄이기만 하므로 다른 단어장과의 충돌(40010)은 검사하지 않는다. alias 가 trim 후 빈 문자열이면 400.
     *
     * @tags V3-WordDictionary
     * @name WordDictionaryControllerRemoveAlias
     * @summary 단어장 aliases 단어 하나 제거 (인라인)
     * @request DELETE:/v3/api/word-dictionary/{id}/aliases
     * @secure
     * @response `200` `WordDictionaryControllerRemoveAliasData` success
     */
    wordDictionaryControllerRemoveAlias: (
      id: any,
      data: WordDictionaryControllerRemoveAliasBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<WordDictionaryControllerRemoveAliasData, any>({
        path: `/v3/api/word-dictionary/${id}/aliases`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
